import React, { useState } from 'react';
import Nav from '../landing/nav';
import PersonIcon from '@mui/icons-material/Person';

const candidatesData = [
 {
    "partyName": "HIRAYA",
    "candidates": {
      "President": "LAGUNAY, JANINE",
      "Vice President": "YAMOMO, SEAN DANIEL",
      "Secretary": "MACADAAG, REYHAN",
      "Treasurer": "CASERES, XAKIAH XYZA",
      "Auditor": "FLORES, MIEL ALEXA",
      "PIO": [
        "DABATIAN, JEZZA",
        "CUBERO, CHLOE JADE"
      ],
      "Protocol Officer": "BAGARES, ESTHEPHANE G.",
      "Representatives": {
        "8": [
          "RAPIRAP, DREAYANS",
          "LUMAHANG, JAMES CLINTON",
          "DABALOS, ERIKA",
          "TANGERES, MAEGAN",
          "NAGALES, SOFIA",
          "RABANES, REILEIGH"
        ],
        "9": [
          "MIRAR, LEANNA ANGELI",
          "SOLON, STEFFI AMBER A.",
          "RAFAL, BRENNA JAEN B.",
          "AJONAN, DAN JOSEPH A."
        ],
        "10": [
          "MAMA-O, SITTIE ALMIRAH",
          "FRANCIS, ARNIL S.",
          "CAPAWA, PRECIOUS XYRA",
          "DELA PEÑA, PRINCESS RAYANNE"
        ]
      }
    }
  },
  {
    "partyName": "SWAGG",
    "candidates": {
      "President": "LEOPOLDO, JEFFY",
      "Vice President": "ELARMO, MEL",
      "Secretary": "ARATIA, ZAIVELIEH",
      "Treasurer": "MAGLANGIT, MARY JOY",
      "Auditor": "BINASING, SAIDONA",
      "PIO": [
        "SUIZO, AVELINO",
        "DIAZ, FAITH"
      ],
      "Protocol Officer": "ENRIQUEZ, MICHELLE",
      "Representatives": {
        "8": [
          "BALISADO, ANIKA",
          "MABA, ALI",
          "QUIÑO, ALTHEA",
          "SUMALPONG, KISSHA",
          "NADAYAG, XANTINE"
        ],
        "9": [
          "SHAWQI, EZZAH",
          "AVERIA, STARRH",
          "VERDEJO, MATTHEW"
        ],
        "10": [
          "DURANO, MARK",
          "SIA, ANGEL",
          "CUTANDA, JUSTINE",
          "VALENTE, KYLE"
        ]
      }
    }
  }
];

const Candidates = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    // Robust check to see if there is any actual candidate data across all parties
    const isDataBlank = () => {
        if (!candidatesData || candidatesData.length === 0) return true;

        // Check if every single party in the list has no President named
        // You can expand this to check other fields if necessary
        const hasNoCandidates = candidatesData.every(party => 
            !party.candidates.President || party.candidates.President.trim() === ""
        );

        return hasNoCandidates;
    };

  return (
    <div className="bg-slate-50 min-h-screen">
      <Nav menuOpen={menuOpen} toggleMenu={toggleMenu} />
      <div style={{ paddingTop: '110px' }} className="pb-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="mb-12 text-center">
          <h1 className="text-4xl font-black tracking-tight text-slate-950">Candidates for SSLG Election 2026</h1>
          <p className="mt-2 text-lg text-slate-800 font-bold">Meet the candidates from all partylists.</p>
        </header>

        {isDataBlank() ? (
          <div className="flex flex-col items-center justify-center py-20 bg-white rounded-3xl shadow-md border border-slate-200 animate-pulse">
             <div className="bg-slate-100 p-6 rounded-full mb-4">
                <PersonIcon style={{ fontSize: 80, color: '#cbd5e1' }} />
             </div>
             <h2 className="text-3xl font-black text-slate-900">Candidates info pending.</h2>
             <p className="text-slate-500 mt-2 font-bold">The official list of candidates is currently being finalized.</p>
          </div>
        ) : (
          candidatesData.map((party) => (
            <div key={party.partyName} className="mb-16">
              <h2 className="text-3xl font-black text-slate-900 border-b-4 border-blue-600 pb-2 mb-8">{party.partyName}</h2>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                {Object.entries(party.candidates).map(([position, name]) => {
                  if (position === 'Representatives' || Array.isArray(name) || !name || name.trim() === "") return null;
                  return (
                    <div key={name} className="bg-white rounded-xl shadow-md p-6 text-center transition-all transform hover:-translate-y-2 border border-slate-100">
                      <div className="bg-blue-50 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <PersonIcon style={{ fontSize: 50, color: '#2563eb' }} />
                      </div>
                      <h3 className="text-lg font-black text-slate-900">{name}</h3>
                      <p className="text-blue-600 font-bold uppercase text-sm tracking-wider">{position}</p>
                    </div>
                  );
                })}
                
                {party.candidates.PIO && party.candidates.PIO[0] !== "" && (
                   <div className="bg-white rounded-xl shadow-md p-6 text-center transition-all transform hover:-translate-y-2 border border-slate-100">
                      <div className="bg-blue-50 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <PersonIcon style={{ fontSize: 50, color: '#2563eb' }} />
                      </div>
                      <h3 className="text-lg font-black text-slate-900">{party.candidates.PIO.join(' & ')}</h3>
                      <p className="text-blue-600 font-bold uppercase text-sm tracking-wider">P.I.O.</p>
                    </div>
                )}
              </div>

              {/* Only show Representatives header if there is at least one rep name available */}
              <h3 className="text-2xl font-black text-slate-900 mt-12 mb-6">Representatives</h3>
              <div className="space-y-8">
                {Object.entries(party.candidates.Representatives).map(([grade, reps]) => {
                  if (!reps || reps[0] === "" || reps.length === 0) return null;
                  return (
                    <div key={grade}>
                      <h4 className="text-xl font-black text-slate-800 mb-4 bg-slate-200 px-4 py-1 rounded-lg inline-block">{`Grade ${grade}`}</h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                        {reps.map((rep) => (
                           <div key={rep} className="bg-white rounded-xl shadow-md p-4 text-center transition-all transform hover:-translate-y-1 border border-slate-100">
                              <PersonIcon style={{ fontSize: 40, margin: '0 auto 8px', color: '#64748b' }} />
                              <h4 className="font-bold text-slate-900">{rep}</h4>
                           </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Candidates;